export function LogoMark({ className = "h-10 w-10" }) {
    return (
        <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
            <rect width="64" height="64" rx="14" fill="#EB5A28" />
            <circle cx="32" cy="32" r="15.5" fill="none" stroke="#FAF9F5" strokeWidth="6" />
            <rect x="8" y="29" width="12" height="6" rx="3" fill="#FAF9F5" />
            <rect x="26" y="29" width="12" height="6" rx="3" fill="#FAF9F5" />
            <rect x="44" y="29" width="12" height="6" rx="3" fill="#FAF9F5" />
        </svg>
    );
}

export function Wordmark({ light = false, markClass = "h-9 w-9 sm:h-10 sm:w-10" }) {
    return (
        <span className="flex items-center gap-2.5 sm:gap-3">
            <LogoMark className={markClass} />
            <span className="leading-none">
                <span
                    className={`block whitespace-nowrap font-display text-[13px] sm:text-base lg:text-lg font-extrabold tracking-tight ${
                        light ? "text-paper" : "text-ink"
                    }`}
                >
                    OSM CARGO MOVERS
                </span>
                <span
                    className={`mt-1.5 block whitespace-nowrap text-[8px] font-semibold uppercase tracking-[0.24em] sm:text-[9px] sm:tracking-[0.3em] ${
                        light ? "text-paper/60" : "text-fog"
                    }`}
                >
                    One Stop Movers
                </span>
            </span>
        </span>
    );
}
